import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserTagDataFragment, useDeleteUserTagMutation } from '../../../api';
import { useAlert } from '../../../components/AlertProvider';
import ConfirmDialog from '../../../components/ConfirmDialog';

export type TagDeleteDialogProps = {
    tag: UserTagDataFragment | null;
    open: boolean;
    onClose: () => void;
    onDeleted: () => Promise<void>;
};

const TagDeleteDialog = ({ tag, open, onClose, onDeleted }: TagDeleteDialogProps) => {
    const { t } = useTranslation(['tagManagementPage', 'common']);
    const { show } = useAlert();
    const [deleteTag] = useDeleteUserTagMutation();

    return (
        <ConfirmDialog
            body={t('tagManagementPage:deleteConfirmation', { name: tag?.name })}
            continueBtn={t('common:delete')}
            setContinueConfirmDialog={async () => {
                if (!tag) {
                    return;
                }

                await deleteTag({ variables: { tagId: tag.id } });
                await onDeleted();
                show('success', t('tagManagementPage:messages.deleted'));
                onClose();
            }}
            setHideConfirmDialog={onClose}
            show={open}
            title={t('tagManagementPage:deleteTitle')}
        />
    );
};

export default TagDeleteDialog;
